import { useEffect } from 'react';
import { analytics, ChatEventName, EventCategory } from '../..';
// tracks event getting fired on user input on chat
export var useSmartChatTracking = function (phoneNumber, email, firstName) {
    useEffect(function () {
        if (phoneNumber) {
            // track when a phone number has entered
            analytics({
                event_name: ChatEventName.PHONE_NUMBER_ENTERED,
                category: EventCategory.CHAT,
            });
        }
    }, [phoneNumber]);
    useEffect(function () {
        if (email) {
            // track when a email has entered
            analytics({
                event_name: ChatEventName.EMAIL_ENTERED,
                category: EventCategory.CHAT,
            });
        }
    }, [email]);
    useEffect(function () {
        if (firstName) {
            // track when a firstName has entered
            analytics({
                event_name: ChatEventName.FIRST_NAME_ENTERED,
                category: EventCategory.CHAT,
            });
        }
    }, [firstName]);
};
//# sourceMappingURL=index.js.map